import React, { FC } from 'react';
import { ButtonFieldProps } from '../models';
import './ButtonField.scss';

const ButtonField: FC<ButtonFieldProps> = ({ ariaLabel, value, ts, ...other }) => (
  <button className="button-field" aria-label={ts[ariaLabel]} type="submit" {...other}>
    {ts[value]}
  </button>
);

export default ButtonField;
